// export const flipContractAddress = "0x59328EdA24d5601989D7b55a39c3f16a16caaE2E" // local
export const flipContractAddress = "0x6fea17Fb47894A5059959625Be8F0BC604ab8F2A" // Ropsten

